module.exports = __webpack_public_path__ + "static/scale-model-of-rush-athens-trampoline-park-in-athens-georgia-63dcd991d598b23cd68491eaf9152526.png";